export type TNativeOfflineAudioContext = OfflineAudioContext;
